<template>
  <div
    id="VisitorRealNameRigistration"
    v-loading="isClickSend"
  >
    <div class="header">
      <img
        src="@/assets/img/login/logo.png"
        alt="智生活 Logo"
      >
    </div>
    <div class="main">
      <template v-if="!isNext">
        <div>
          <div class="communityName">
            {{ comInfo.name }}
          </div>
          <div class="title">
            現場訪客登記
          </div>
          <form action="">
            <div class="input-group">
              <label for="cellphone"><span class="must">* </span>手機號碼</label>
              <input
                id="cellphone"
                v-model="formData.cellphone"
                type="tel"
                placeholder="請輸入"
                maxlength="10"
                :class="{ warning : warningObj.cellphone }"
                @input="checkForm('cellphone')"
              >
            </div>
          </form>
        </div>
        <div class="button-block">
          <button @click="goNext">
            下一步
          </button>
        </div>
      </template>
      <template v-else>
        <div>
          <form action="">
            <div class="input-group">
              <label for="cause"><span class="must">* </span>訪客事由</label>
              <select
                id="cause"
                v-model="formData.cause"
                name=""
                :class="{ warning : warningObj.cause }"
                @change="checkForm('cause')"
              >
                <option
                  value="0"
                  disabled
                  hidden
                >
                  請選擇
                </option>
                <option
                  v-for="item in causeList"
                  :key="item.Id"
                  :value="item.Id"
                >
                  {{ item.Name }}
                </option>
              </select>
            </div>
            <div class="input-group">
              <label for="tablet"><span class="must">* </span>拜訪戶別</label>
              <select
                id="dong"
                v-model="selectedDongIndex"
                name=""
                @change="selectDong"
              >
                <option
                  value="-1"
                  disabled
                  hidden
                >
                  請選擇
                </option>
                <option
                  v-for="(item, index) in tabletList"
                  :key="index"
                  :value="index"
                >
                  {{ item.Tag }}
                </option>
              </select>
              <select
                v-if="selectedDongIndex >= 0"
                id="floor"
                v-model="selectedFloorIndex"
                name=""
                :disabled="tabletList[selectedDongIndex].FloorAndTablets.length === 1"
                @change="selectFloor"
              >
                <option
                  value="-1"
                  disabled
                  hidden
                >
                  請選擇樓層
                </option>
                <option
                  v-for="(item, index) in tabletList[selectedDongIndex].FloorAndTablets"
                  :key="index"
                  :value="index"
                >
                  {{ item.Floor }}樓
                </option>
              </select>
              <select
                v-else
                name=""
                disabled
              >
                <option value="">
                  請選擇樓層
                </option>
              </select>
              <select
                v-if="selectedFloorIndex >= 0"
                id="tablet"
                v-model="formData.tablet"
                name=""
                :class="{ warning : warningObj.tablet }"
                :disabled="tabletList[selectedDongIndex].FloorAndTablets[selectedFloorIndex].Tablets.length === 1"
                @change="checkForm('tablet')"
              >
                <option
                  value=""
                  disabled
                  hidden
                >
                  請選擇戶別
                </option>
                <option
                  v-for="item in tabletList[selectedDongIndex].FloorAndTablets[selectedFloorIndex].Tablets"
                  :key="item.Id"
                  :value="item.Id"
                >
                  {{ item.Name }}
                </option>
              </select>
              <select
                v-else
                name=""
                :class="{ warning : warningObj.tablet }"
                disabled
              >
                <option value="">
                  請選擇戶別
                </option>
              </select>
            </div>
            <div class="input-group">
              <label for="cellphone"><span class="must">* </span>訪客/廠商名稱</label>
              <input
                id="cellphone"
                v-model="formData.name"
                type="text"
                placeholder="請輸入"
                maxlength="20"
                :class="{ warning : warningObj.name }"
                @input="checkForm('name')"
              >
            </div>
            <div class="input-group">
              <label for="licensePlateNumber">{{ $t('Guest.LicensePlateNumber') }}</label>
              <input
                id="licensePlateNumber"
                v-model="formData.licensePlateNumber"
                type="text"
                :placeholder="$t('Guest.PleaseEnter')"
                maxlength="8"
                @input="checkForm('licensePlateNumber')"
              >
            </div>
            <div class="input-group">
              <label for="remark">{{ $t('Guest.Remark') }}</label>
              <input
                id="remark"
                v-model="formData.remark"
                type="text"
                :placeholder="$t('Guest.PleaseEnter')"
                maxlength="30"
                @input="checkForm('remark')"
              >
            </div>
          </form>
        </div>
        <div class="button-block">
          <div class="button-note">
            請抵達社區後再送出登記資訊<br>避免現場作業困難
          </div>
          <button @click="sendRigistration">
            確認登記
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { isValidCellphone, isValidCellphoneNotContainZero } from '@/js/utils/unitValidate'
import { formatLicensePlateNumber } from '@/js/utils/guest'

export default {
  data () {
    return {
      comInfo: {
        id: '',
        name: ''
      },
      warningObj: {
        cause: false,
        cellphone: false,
        name: false,
        tablet: false
      },
      formData: {
        cause: 0,
        tablet: '',
        cellphone: '',
        name: '',
        licensePlateNumber: '',
        remark: ''
      },
      causeList: [],
      tabletList: [],
      selectedDongIndex: -1,
      selectedFloorIndex: -1,
      isNext: false,
      isClickNext: false,
      isSend: false,
      isClickSend: false,
      token: {
        accessToken: '',
        refreshToken: ''
      }
    }
  },
  async mounted () {
    this.formData = {
      cause: 0,
      tablet: '',
      cellphone: '',
      name: '',
      licensePlateNumber: '',
      remark: ''
    }
    try {
      await this.getToken()
      await this.getCommunityData()
    } catch (err) {
      console.log(err)
    }
  },
  methods: {
    getGuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line eqeqeq
        const r = Math.random() * 16 | 0; const v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    getToken () {
      const guid = this.getGuid()
      const url = `${process.env.VUE_APP_HOUSEKEEPER_MOBILE_URL}/v1/Identity/Login/Anonymous`
      const authorizationCode = this.$route.query.AuthorizationCode?.replace(/ /gi, '+')
      return new Promise((resolve, reject) => {
        axios(url, {
          method: 'POST',
          headers: {
            authority: authorizationCode,
            'x-requestid': guid
          }
        }).then(res => {
          console.log(res)
          this.token.accessToken = res.data.AccessToken
          this.token.refreshToken = res.data.RefreshToken
          resolve(res.data)
        }).catch(err => {
          console.log(err)
          reject(err)
        })
      })
    },
    getCommunityData () {
      const url = `${process.env.VUE_APP_HOUSEKEEPER_MOBILE_URL}/v1/Guest/OnSiteRegisterFormInfo`
      return new Promise((resolve, reject) => {
        axios(url, {
          method: 'GET',
          headers: {
            authorization: `Bearer ${this.token.accessToken}`
          }
        }).then(res => {
          console.log(res)
          this.comInfo.id = res.data.CommunityInfo.Id
          this.comInfo.name = res.data.CommunityInfo.Name
          this.causeList = res.data.CauseTypes
          this.tabletList = res.data.StructuredTablets
          resolve()
        }).catch(err => {
          console.log(err)
          reject(new Error('取得社區資訊失敗'))
        })
      })
    },
    selectDong () {
      this.formData.tablet = ''
      this.selectedFloorIndex = -1
      if (this.tabletList[this.selectedDongIndex].FloorAndTablets.length === 1) {
        this.selectedFloorIndex = 0
        this.selectFloor()
      }
    },
    selectFloor () {
      this.formData.tablet = ''
      if (this.tabletList[this.selectedDongIndex].FloorAndTablets[this.selectedFloorIndex].Tablets.length === 1) {
        this.formData.tablet = this.tabletList[this.selectedDongIndex].FloorAndTablets[this.selectedFloorIndex].Tablets[0].Id
        this.checkForm('tablet')
      }
    },
    checkForm (type) {
      switch (type) {
      case 'cellphone':
        if (this.isClickNext) {
          if (isValidCellphoneNotContainZero(this.formData.cellphone)) {
            this.formData.cellphone = `0${this.formData.cellphone}` // 開頭未輸入0,自動補0
            this.warningObj.cellphone = false
          } else if (!isValidCellphone(this.formData.cellphone)) {
            this.warningObj.cellphone = true
          } else {
            this.warningObj.cellphone = false
          }
        }
        break
      case 'cause':
        if (this.formData.cause === 0) {
          this.warningObj.cause = true
        } else {
          this.warningObj.cause = false
        }
        break
      case 'name':
        if (this.isClickSend) {
          if (this.formData.name === '') {
            this.warningObj.name = true
          } else {
            this.warningObj.name = false
          }
        }
        break
      case 'tablet':
        if (this.formData.tablet === '') {
          this.warningObj.tablet = true
        } else {
          this.warningObj.tablet = false
        }
        break
      case 'licensePlateNumber':
        this.formData.licensePlateNumber = formatLicensePlateNumber(this.formData.licensePlateNumber)
        break
      }
    },
    goNext () {
      this.isClickNext = true
      this.checkForm('cellphone')
      if (this.warningObj.cellphone) {
        console.log('手機號碼格式錯誤')
        alert('格式不符')
      } else {
        const url = `${process.env.VUE_APP_HOUSEKEEPER_MOBILE_URL}/v1/Guest/PhoneUser/${this.formData.cellphone}`
        axios(url, {
          method: 'GET'
        }).then(res => {
          console.log(res)
          if (res.data.Name) {
            this.formData.name = res.data.Name
          }
        }).catch(err => {
          console.log(err)
        })
        this.isNext = true
      }
    },
    sendRigistration () {
      this.isClickSend = true
      this.checkForm('cause')
      this.checkForm('name')
      this.checkForm('tablet')
      if (this.warningObj.cause || this.warningObj.name || this.warningObj.tablet) {
        console.log('資料填寫不完整')
        alert('資料填寫不完整')
        this.isClickSend = false
      } else {
        if (this.isSend) {
          return false
        } else {
          this.isSend = true
          const guid = this.getGuid()
          const url = `${process.env.VUE_APP_HOUSEKEEPER_MOBILE_URL}/v1/Guest/OnSiteRegisterForm/${this.comInfo.id}`
          axios(url, {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${this.token.accessToken}`,
              'x-requestid': guid
            },
            data: {
              guestName: this.formData.name,
              cause: this.formData.cause,
              tabletid: this.formData.tablet,
              cellPhone: this.formData.cellphone,
              licensePlateNumber: this.formData.licensePlateNumber,
              remark: this.formData.remark
            }
          }).then(res => {
            console.log(res)
            this.isSend = false
            this.$router.push({ path: '/visitorRealNameSuccess' })
          }).catch(err => {
            console.log(err)
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#VisitorRealNameRigistration {
  .header {
    height: 64px;
    background-color: $mainColor;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 39px;
    }
  }
  .main {
    box-sizing: border-box;
    min-height: calc(100vh - 64px);
    padding: 36px 16px 0px 16px;
    background-color: #fff;
    color: #333333;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .communityName {
      font-size: 17px;
      text-align: center;
    }
    .title {
      font-size: 25px;
      text-align: center;
      font-weight: bold;
      margin-bottom: 32px;
    }
    label {
      display: block;
      font-size: 15px;
      margin-bottom: 4px;
      .must {
        color: #C44536;
      }
    }
    input {
      padding: 10px 12px;
      border: $borderDark4 1px solid;
      border-radius: 4px;
      width: 100%;
      box-sizing: border-box;
      font-size: initial;
      color: #484848;
      margin-bottom: 25px;
    }
    select {
      padding: 10px 12px;
      border: $borderDark4 1px solid;
      border-radius: 4px;
      width: 100%;
      box-sizing: border-box;
      font-size: 15px;
      color: #484848;
      margin-bottom: 25px;
      background-color: #fff;
      -webkit-appearance : none ;
    }
    .warning {
      border: #C44536 2px solid;
      opacity: 1;
      color: rgba(72, 72, 72, 0.7);
    }
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #cccccc;
      opacity: 1; /* Firefox */
    }
    :-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: #cccccc;
    }
    ::-ms-input-placeholder { /* Microsoft Edge */
      color: #cccccc;
    }
    .button-block {
      padding: 0 38px;
      margin-bottom: 32px;
      button {
        width: 100%;
        height: 44px;
        padding: 12px 0;
        background-color: $mainColor;
        color: #fff;
        font-size: 15px;
        border: none;
        border-radius: 22px;
        box-sizing: border-box;
      }
      .button-note {
        color: #F78456;
        font-size: 15px;
        line-height: 1.66666;
        text-align: center;
        margin-bottom: 24px;
      }
    }

  }
}
</style>
